import { render, staticRenderFns } from "./iconIcon.vue?vue&type=template&id=31fee234&"
import script from "./iconIcon.vue?vue&type=script&lang=js&"
export * from "./iconIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports